import { fontWeightConfig, radiusConfig } from '../common';
import { borderColors, colors, hoverBorderColors } from './colors';

export const inputConfiguration = {
  textColor: colors.textMain,
  fontSize: '13px',
  minHeight: '40px',
  bgColor: {
    default: colors.white,
    error: colors.errorLight,
    disabled: '#F5F5F5',
  },
  borderColor: {
    default: borderColors.secondaryLight,
    hover: hoverBorderColors.secondaryLight,
    focus: borderColors.primary,
    error: borderColors.error,
    disabled: '#D9D9D9',
  },
  focusShadow: `0 0 0 4px ${colors.focusShadow}`,
  borderRadius: radiusConfig.input,

  placeholder: {
    size: '13px',
    color: colors.placeholderText,
  },
};
